import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/components/common/api';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-campaign-add-stores',
  templateUrl: './campaign-add-stores.component.html',
  styleUrls: ['./campaign-add-stores.component.scss', '../coupon-setup.scss']
})
export class CampaignAddStoresComponent implements OnInit {
  filter: {insegna: string[], classificationNames: string[], gruppo: string, codici: string[], storeDateEnd: true};
  insegne: any[] = [];
  groupNames: any[] = [];
  classifications: any[] = [];
  groups: any[] = [];
  classificationList: any[] = [];
  stores: any[] = [];
  saveAsGroup = false;
  newGroupName: string = '';
  addedStores: any[] = [];

  @Input() selectedStoresId: string[] = [];
  @Output() onAddStores: EventEmitter<any> = new EventEmitter();

  constructor(
    private campaignService: Campaign2Service,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.initFilter();
    this.groupNames = [{ label: this.translateService.instant('campaign.group'), value: '' }];
    this.searchStoresWithFilter(this.filter);
    Observable.zip(
      this.campaignService.getInsegna(),
      //this.campaignService.getAreaGeo(),//modifica introdotta con KS-6842 per cds
      this.campaignService.getClassification(),
      this.campaignService.listGroups(),
    ).subscribe(([insegne, classification,  groups]) => {
      if (this.insegne.length === 0) {
        insegne.map(insegna => {
          this.insegne.push({
            label: insegna.insegna,
            value: insegna.insegna
          });
        });
      }
      this.classificationList = classification;
      this.groups = groups;
      this.setFilter();
    });
  }

  setFilter() {
    if (this.classifications.length === 0) {
      this.classificationList.forEach(classification => {
        if(classification.name !== null) {
          this.classifications.push({
            label: `${classification.name}`,
            value: `${classification.name}`
          });
        }
      });
    }
    this.groups.forEach(group => {
      this.groupNames.push({
        label: group.name,
        value: group.name
      });
    });
  }

  initFilter() {
    this.filter = {
      insegna: [],
      classificationNames: [],
      gruppo: '',
      codici: [],
      storeDateEnd: true
    };
  }

  searchStoresWithFilter(filters) {
    this.campaignService.getStoresFromFiltersByClassification(filters).subscribe(res => {
      this.stores = res;
    });
  }

  confirmFilters() {
    this.confirmationService.confirm({
      message: this.translateService.instant('campaign.storeFilterConfirm'),
      accept: () => this.searchStoresWithFilter(this.filter),
      acceptLabel: "Ok",
      rejectLabel: this.translateService.instant('common.cancel')
    });
  }

  unselectAll() {
    this.selectedStoresId = [];
  }

  selectAll() {
    this.selectedStoresId = this.stores.map(store => store.id.toString());
  }

  inputGroupName(value: boolean) {
    if(value && this.selectedStoresId.length == 0) {
      return;
    }
    if (!value) {
      this.newGroupName = '';
    }
    this.saveAsGroup = value;
  }

  saveGroup() {
    if(this.newGroupName == '') {
      return;
    }
    const groupData = {
      'name': this.newGroupName,
      'code': Date.now()
    };
    this.inputGroupName(false);
    this.campaignService.createGroup(groupData).subscribe( res => {
      this.newGroupName = '';
      this.campaignService.setStoresInGroup(res.id, this.selectedStoresId.map(store => parseInt(store))).subscribe(() => this.addStores());
    });
  }

  addStores() {
    for(let storeId of this.selectedStoresId) {
      const filteredStore = this.stores.filter(store => store.id == +storeId)[0];
      if (filteredStore) {
        this.addedStores.push(filteredStore);
      }
    }
    this.onAddStores.emit({addedStoresId: this.selectedStoresId, addedStores: this.addedStores});
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-add-stores/campaign-add-stores.component.ts